export default __webpack_public_path__ + "assets/_Chapters/ServicesZerspanung/Filter/walter.png";